import { Dialog, DialogActions, DialogContent, DialogTitle, Stack, Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { makeStyles } from 'tss-react/mui';
import PaiButton from './pai-button';

interface Props {
  open: boolean;
  title: string;
  textContent: string | string[] | React.ReactNode;

  handleClose(): void;
}

const PaiInfoDialog: React.FC<Props> = ({ open, title, textContent, handleClose }) => {
  const { classes } = useStyles();
  const { t } = useTranslation();

  return (
    <Dialog classes={{ paper: classes.paper }} open={open} fullWidth={true} maxWidth={'xs'}>
      <DialogTitle className={classes.title}>
        <Typography className={classes.titleText}>{title}</Typography>
      </DialogTitle>
      <DialogContent className={classes.content}>
        {typeof textContent === 'string' ? (
          <Typography className={classes.text}>{textContent}</Typography>
        ) : Array.isArray(textContent) ? (
          <Stack gap={1}>
            {textContent.map((text, index) => (
              <Typography key={index} className={classes.text}>
                {text}
              </Typography>
            ))}
          </Stack>
        ) : (
          textContent
        )}
      </DialogContent>
      <DialogActions className={classes.actions}>
        <PaiButton text={t('ok')} size={'small'} border={'rounded'} action={handleClose} />
      </DialogActions>
    </Dialog>
  );
};

const useStyles = makeStyles()((theme) => ({
  paper: {
    borderRadius: '16px',
  },
  title: {
    background: 'linear-gradient(to right, #5044FF, #4AA4FF)',
  },
  titleText: {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: 'bold',
    textTransform: 'uppercase',
    color: '#FFF',
    textAlign: 'center',
  },
  content: {
    padding: '24px !important',
    whiteSpace: 'pre-wrap',
  },
  text: {
    fontSize: theme.typography.pxToRem(15),
    whiteSpace: 'pre-wrap',
  },
  actions: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    gap: '16px',
    padding: '0 24px 20px 24px',
  },
}));

export default PaiInfoDialog;
